import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { FormikProps } from 'formik'
import { Messages } from 'primereact/messages'

import { PanelContainer } from '../../../../../components/Panel'
import { EmailChips } from '../../../../settings/EmailForm/EmailChips'
import { AddSupplierFormDto } from '../../data/model'
import { FormFieldName } from '../AddSupplier.form'

type Props = {
  formik: FormikProps<AddSupplierFormDto>
  separator: string
  isFormFieldInvalid: (name: FormFieldName) => boolean
  wrongInboundEmails: string[] | null
  wrongOutboundEmails: string[] | null
  getFormErrorMessage: (name: FormFieldName) => JSX.Element
  isRequestRunning: boolean
}
export const Email: React.FC<Props> = ({
  formik,
  separator,
  isFormFieldInvalid,
  wrongInboundEmails,
  wrongOutboundEmails,
  getFormErrorMessage,
  isRequestRunning,
}) => {
  const { t } = useTranslation()
  const panelId = 'supplier-email'
  const messagesRef = useRef<Messages>(null)

  useEffect(() => {
    if (messagesRef.current) {
      messagesRef.current.clear()
      messagesRef.current.show({
        id: '1',
        sticky: true,
        severity: 'info',
        detail: t('settings.email.notifications.message'),
        closable: false,
      })
    }
  }, [])

  return (
    <PanelContainer
      header={t('settings.email.title')}
      id={panelId}
      toggleable={false}
    >
      <div className="grid">
        <div className="col-12 lg:col-4">
          <p>{t('settings.email.notifications.subtitle')}</p>
        </div>
        <div className="col-12 lg:col-7 lg:col-offset-1">
          <Messages ref={messagesRef} />

          {/* Inbound */}
          <EmailChips
            id="inboundValue"
            label={t('settings.email.notifications.inbound.label')}
            value={formik.values.inboundValue}
            separator={separator}
            formik={formik}
            isInvalid={isFormFieldInvalid('inboundValue')}
            errorMessage={getFormErrorMessage('inboundValue')}
            wrongEmails={wrongInboundEmails}
            disabled={isRequestRunning}
            isLoading={false}
          />

          {/* Outbound */}
          <EmailChips
            id="outboundValue"
            label={t('settings.email.notifications.outbound.label')}
            value={formik.values.outboundValue}
            separator={separator}
            formik={formik}
            isInvalid={isFormFieldInvalid('outboundValue')}
            errorMessage={getFormErrorMessage('outboundValue')}
            wrongEmails={wrongOutboundEmails}
            disabled={isRequestRunning}
            isLoading={false}
          />
        </div>
      </div>
    </PanelContainer>
  )
}
